import { useContext } from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import TruncateMarkup from "react-truncate-markup";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar, Box, Stack, Typography } from "@mui/material";
//Import from project
import "./classcard.scss";
import { AuthContext } from "../../../Context/AuthContext";
import ClassAction from "./ClassAction";
import musicClassImage from "../../../Assets/music-class.png";
export default function ClassCard({ data, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let teacherId = params.get("teacherId");

  return (
    <Box className="card">
      <Stack direction="column">
        <Box className={"status-card"}>
          <Stack direction="row" alignItems="center">
            <Typography className={data?.isComplete ? "complete" : "studying"}>
              <Box className="dot" />
              {data?.isComplete ? t("thead_completed") : t("thead_studying")}
            </Typography>
          </Stack>
        </Box>
        {/* <Box className="action">
          <ClassAction editData={data} setRefetch={setRefetch} />
        </Box> */}
        <Card sx={{ boxShadow: "none", marginTop: 2 }}>
          <CardMedia
            sx={{ objectFit: "scale-down" }}
            alt="loading..."
            image={musicClassImage}
            height="166"
            component="img"
          />
        </Card>

        <Box
          sx={{ padding: 2.5, paddingTop: 1.5 }}
          onClick={() =>
            navigate(
              `/teacher/teacher-detail/class-detail?classId=${data?._id}&teacherId=${teacherId}`
            )
          }
        >
          <Stack spacing={1}>
            <Stack spacing={0.8}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={0.5}
              >
                <TruncateMarkup lines={1}>
                  <Typography className="card-title">
                    {data?.courseId?.enName + " " + data?.className}
                  </Typography>
                </TruncateMarkup>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="flex-start"
                  justifyContent="center"
                >
                  <PeopleAltIcon sx={{ color: "#d24029", fontSize: 22 }} />
                  <Typography className="total-people">
                    {data?.totalStudent || 0}
                  </Typography>
                </Stack>
              </Stack>

              <TruncateMarkup lines={2}>
                <Typography className="description">{data?.remark}</Typography>
              </TruncateMarkup>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1.3} alignItems="center">
                <Avatar alt="Loading..." src={data?.teacherId?.profile} />
                <Stack direction="column">
                  <Typography className="teacher-name">
                    {data?.teacherId?.userName}
                  </Typography>
                  <Typography className="position">
                    {data?.teacherId?.role}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction="column">
                <Typography className="lesson">
                  {data?.totalLesson} {t("thead_lesson")}
                </Typography>
                <Typography className="lesson">
                  {data?.totalHour} {t("thead_hour")}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
